import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as schemaGraph from './schema-graph'

@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.illustration.emptyState.Component,
    ds.input.search.Component,
    ds.layout.page.child.header.Component,
    ds.layout.page.Component,
    ds.overlay.centered.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
    schemaGraph.Component,
  ],
  selector: 'atn-dms-graph-page',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {}
